import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Skeleton } from '@/components/ui/skeleton'
import { ConsentFlags, EmailConfidence, OutreachBadge } from './ProspectBadges'
import type { Prospect } from '../api/prospectsApi'

interface ProspectTableProps {
  prospects: Prospect[]
  isLoading?: boolean
  onSelect: (prospect: Prospect) => void
}

export function ProspectTable({ prospects, isLoading, onSelect }: ProspectTableProps) {
  if (isLoading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    )
  }

  if (!prospects.length) {
    return <p className="py-12 text-center text-sm text-slate-500">No prospects match these filters.</p>
  }

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Artist</TableHead>
            <TableHead>Contact</TableHead>
            <TableHead>Outreach</TableHead>
            <TableHead className="text-right">Chapters</TableHead>
            <TableHead className="text-right">Followers</TableHead>
            <TableHead>Flags</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {prospects.map((p) => (
            <TableRow
              key={p.id}
              className="cursor-pointer hover:bg-slate-50"
              onClick={() => onSelect(p)}
            >
              <TableCell>
                <div className="font-medium">{p.displayName || p.handle}</div>
                <div className="text-xs text-slate-500">@{p.handle}</div>
              </TableCell>
              <TableCell>
                <EmailConfidence prospect={p} />
              </TableCell>
              <TableCell>
                <OutreachBadge status={p.outreachStatus} />
                {p.contactAttempts > 0 && (
                  <span className="ml-2 text-xs text-slate-500">
                    {p.contactAttempts}&times;
                  </span>
                )}
              </TableCell>
              <TableCell className="text-right text-sm">
                {p.readinessTier ?? '—'}
              </TableCell>
              <TableCell className="text-right text-sm tabular-nums">
                {p.followers?.toLocaleString() ?? '—'}
              </TableCell>
              <TableCell>
                <ConsentFlags prospect={p} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
